import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import {
  BinIcon2,
  CheckCircleIcon,
  EditIcon2,
  XCircleIcon,
} from "../../../images/icons/icons";
import { NoImage } from "../../../exports/Images";
import TableSkeleton from "../../common-components/TableSkeleton";

const AddonCategoriesLists = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { addonCategories, addonCategoriesLoading } = useSelector(
    (state) => state.plans
  );

  const handleDeleteCategory = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/addoncat/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Category deleted successfully!"
            );
            callFunction();
          } else {
            toast.error(response?.message || "Cannot delete category!");
          }
        } catch (error) {
          toast.error(error?.message || "Failed to delete category");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to delete this category?`
      );
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
            {row?.name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "image",
      text: "Image",
      formatter: (_, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || NoImage}
              alt={row?.name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_image",
                  rowData: row,
                }))
              }
              style={{ cursor: row?.image ? "pointer" : "default" }}
            />
          </div>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.description ? "link" : ""}`}
            onClick={() =>
              row?.description &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "description",
                rowData: row,
              }))
            }
          >
            {row?.description ? "read" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "is_recommended",
      text: "Recommended",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_recommended ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "is_live",
      text: "Live",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_live ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "is_pt",
      text: "PT",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_pt ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "is_free",
      text: "Free",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_free ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {/* <button
            className="actionBtn icon view"
            onClick={(e) =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "description",
                rowData: row,
              }))
            }
            style={{
              border: "1px solid #bc0909",
              color: "#bc0909",
              borderRadius: "12px",
              cursor: "pointer",
            }}
          >
            <ViewListIcon />
          </button> */}

          <button
            className="actionBtn icon edit"
            onClick={(e) =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit",
                rowData: row,
              }))
            }
          >
            <EditIcon2 />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDeleteCategory(filters);
            }}
          >
            <BinIcon2 />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter mt30 overflowAuto separatedTable">
      {addonCategoriesLoading ? (
        <TableSkeleton
          columns={tbColumns.length || 10}
          rows={pageLimit * 2 || 20}
        />
      ) : (
        <PaymentLinkTable
          tableData={addonCategories?.data || []}
          tableColumns={tbColumns}
          tablePagination={addonCategories?.pagination || []}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default AddonCategoriesLists;
